import Vue from 'vue';
import Vuex from 'vuex';
import { appModule, AppState, FloorState } from './modules/app';
import { homeModule, HomeState } from './modules/home';
import { houseSizeModule, HouseSizeState } from './modules/houseSize';
import { roofShapeModule } from './modules/roofShape';
import { basementModule } from './modules/basement';
import { groundFloorModule, GroundFloorState } from './modules/groundFloor';
import { upperFloorModule, UpperFloorState } from './modules/upperFloor';
import { atticModule } from './modules/attic';
import { summaryModule, SummaryState } from './modules/summary';
import { configurationModule, ConfigurationState } from './modules/configuration';
import { contactModule, ContactState } from './modules/contact';
import { transitionsModule, TransitionsState } from './modules/transitions';
import { notifyModule, NotifyState } from './modules/notify';

Vue.use(Vuex);

const RESTORE_STATE = 'RESTORE_STATE';

export interface RootState {
  app: AppState;
  transitions: TransitionsState;
  configuration: ConfigurationState;
  home: HomeState;
  houseSize: HouseSizeState;
  roofShape: FloorState;
  basement: FloorState;
  groundFloor: GroundFloorState;
  upperFloor: UpperFloorState;
  attic: FloorState;
  summary: SummaryState;
  contact: ContactState;
  notify: NotifyState;
}

export default new Vuex.Store({
  modules: {
    app: appModule,
    transitions: transitionsModule,
    configuration: configurationModule,
    home: homeModule,
    houseSize: houseSizeModule,
    roofShape: roofShapeModule,
    basement: basementModule,
    groundFloor: groundFloorModule,
    upperFloor: upperFloorModule,
    attic: atticModule,
    summary: summaryModule,
    contact: contactModule,
    notify: notifyModule
  },
  state: undefined,
  getters: {},
  actions: {
    restoreState({ commit }, stateToRestore: RootState) {
      // Don't restore open notifications and modals
      stateToRestore.notify.openNotifications = stateToRestore.notify.openModals = [];

      commit(RESTORE_STATE, stateToRestore);
    },
    resetState({ dispatch, state }) {
      Object.keys(state).forEach(module => dispatch(`${module}/resetState`));
    }
  },
  mutations: {
    [RESTORE_STATE](_state, stateToRestore: RootState) {
      this.replaceState({ ...stateToRestore });
    }
  }
});
